export const environment = {
  production: true,
  workerEnabled: true,
  channelsVersion: '2025.4.0.955',
  apiUrl: 'assets/data/appConfig-production.json'
};
